import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore'

export function UserCallbackPage() {
  const isLoading = useAuthStore((s) => s.isLoading)
  const isAdmin = useAuthStore((s) => s.isAdmin)
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoading) return
    if (isAdmin) {
      navigate('/admin/rooms', { replace: true })
    } else {
      navigate('/', { replace: true })
    }
  }, [isLoading, isAdmin, navigate])

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <div className="flex flex-col items-center gap-4">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-600 border-t-transparent" />
        <p className="text-gray-500 text-sm">Signing you in…</p>
      </div>
    </div>
  )
}
